import React from 'react';
import {FormattedMessage} from 'react-intl';
import {Modal} from '@forecast-it/design-system';
import {PERMISSION_TYPE} from '../../Permissions';
import {hasPermission} from '@/forecast-app/shared/util/PermissionsUtil';

type HubspotMissingScopesModalProps = {
	closeModal: () => void;
	onReconnect: () => void;
};

const HubspotMissingScopesModal = ({closeModal, onReconnect}: HubspotMissingScopesModalProps): JSX.Element => {
	return (
		<Modal onCloseModal={closeModal}>
			<Modal.Title>
				<FormattedMessage id="hubspot.missing_scopes_modal.title" />
			</Modal.Title>
			<Modal.Content>
				<FormattedMessage
					id={
						hasPermission(PERMISSION_TYPE.MANAGE_ACCOUNT_SETTINGS)
							? 'hubspot.missing_scopes_modal.body_admin'
							: 'hubspot.missing_scopes_modal.body'
					}
				/>
			</Modal.Content>
			<Modal.Footer>
				{hasPermission(PERMISSION_TYPE.MANAGE_ACCOUNT_SETTINGS) && (
					<Modal.PrimaryFooterButton onPress={onReconnect}>
						<FormattedMessage id="hubspot.missing_scopes_modal.reconnect" />
					</Modal.PrimaryFooterButton>
				)}
				<Modal.SecondaryFooterButton onPress={closeModal}>
					<FormattedMessage id="common.cancel" />
				</Modal.SecondaryFooterButton>
			</Modal.Footer>
		</Modal>
	);
};

export default HubspotMissingScopesModal;
